export default __webpack_public_path__ + "static/media/electronic-seal.c66f1cbb.png";